import React from 'react';
import { cn } from '../../utils/cn';

const Badge = React.forwardRef(({ 
  children, 
  variant = 'orange', 
  className, 
  ...props 
}, ref) => {
  const variants = {
    orange: 'reddit-badge-orange',
    blue: 'reddit-badge-blue',
    green: 'reddit-badge-green',
  };
  
  return (
    <span
      ref={ref}
      className={cn('reddit-badge', variants[variant], className)}
      {...props}
    >
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export default Badge;